import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';

const SummaryCards = ({ summary, lastUpdated }) => {
  if (!summary) return null;

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString();
  };

  return (
    <Row className="mb-4">
      <Col md={3}>
        <Card className="stats-card text-white">
          <Card.Body className="text-center">
            <Card.Title>Current Interest</Card.Title>
            <h2>{summary.latest_value}</h2>
            <small>Search Volume Index</small>
          </Card.Body>
        </Card>
      </Col>
      <Col md={3}>
        <Card className="stats-card text-white">
          <Card.Body className="text-center">
            <Card.Title>5-Year Average</Card.Title>
            <h2>{Math.round(summary.avg_interest)}</h2>
            <small>Monthly Average</small>
          </Card.Body>
        </Card>
      </Col>
      <Col md={3}>
        <Card className="stats-card text-white">
          <Card.Body className="text-center">
            <Card.Title>Data Points</Card.Title>
            <h2>{summary.total_weeks}</h2>
            <small>Weekly Observations</small>
          </Card.Body>
        </Card>
      </Col>
      <Col md={3}>
        <Card className="stats-card text-white">
          <Card.Body className="text-center">
            <Card.Title>Last Updated</Card.Title>
            <h6>{formatDate(lastUpdated)}</h6>
            <small>Data Freshness</small>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};

export default SummaryCards;